import { DropDownList } from './../../../models/DropDownList.model';
import { Component, OnInit, Input } from '@angular/core';
import {Approval} from '../../../models/Approval.model';
import {ApprovalService} from "../../../services/approval.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastsManager} from "ng2-toastr";
import {ConsultantService} from "../../../services/consultant.service";
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { ElegibleForDiscount } from '../../../models/ElegibleForDiscount.model';

@Component({
  selector: 'app-approval-box',
  templateUrl: './approval-box.component.html',
  styleUrls: ['./approval-box.component.scss']
})
export class ApprovalBoxComponent implements OnInit {
  @Input() approvalId;
  @Input() approvalsNumber;
  @Input() index;
  @Input() status;
  @Input() days;
  @Input() approvalType;
  @Input() descontar;
  @Input() projectsFin;
  @Input() extras;

    _id: String;
    approval: Approval = new Approval();
    totalProjectHours = 0;
    approvedHours:number;
    hourValue;
    contractTotalValue;
    totalValue;
    mensalHours;
    kind;
    honorarium;
    username;
    consultant:any;
    horasAMaisMesDescontar:number = 0;
    pjSelect = new Array();

    constructor(
        private ApprovalService: ApprovalService,
        private route: ActivatedRoute,
        private router: Router,
        public toastr: ToastsManager,
        private consultantService:ConsultantService,
        private projectFinancialService: ProjectFinancialService
    ) { }

    async ngOnInit() {
        await this.getApproval(this.approvalId);

        this.sumProjectHours(this.approval);
        this.totalValue = (this.getKind() == "PJ" && this.getHonorarium()=="Hora Aberta")?(this.totalProjectHours*this.hourValue):this.approval.consultant.contract.totalValue;
    }

    async refreshApprovals(approval){
        this.username = approval.consultant.fcEmail;
        let res = await this.ApprovalService.getHashtrackApprovals(this.username);
        if(res.status==200)
            this.toastr.success("Sincronizado com o Hashtrack!");
        if(res.status==401)
            this.toastr.warning("Cliente não mapeado!");
        if(res.status==400)
            this.toastr.error("Erro ao sincronizar com o Hashtrack!");
        await this.getApproval(this.approvalId)
    }

    async getApproval(_id:String){
        this.approval = await this.ApprovalService.getApproval(_id);
        await this.selectLoad();
        this.consultant = await this.consultantService.getById(this.approval.consultant._id);
        if(this.consultant)
            this.setContract(this.consultant);
        this.days = localStorage.getItem('days');
        this.setValues(this.approval);
        this.sumProjectHours(this.approval)

    }

    setContract(consultant){
        this.approval.consultant.contract.totalValue = this.consultant.contract.totalValue;
        this.approval.consultant.contract.hourValue = this.consultant.contract.hourValue;
        this.approval.consultant.contract.mensalHours = this.consultant.contract.mensalHours;
        this.approval.consultant.contract.soldHourValue = this.consultant.contract.soldHourValue;
    }

    async selectLoad() {

        await this.approval.projects.forEach(async element => {
            var projectsCompany = this.projectsFin.filter(flt => flt.company._id == element.customer.financialId);

            var objProjectCompany = await this.projectFinancialService.preSelectItensDropDown(projectsCompany, element.projectFinancialId);
            
            this.pjSelect.push(objProjectCompany);
            
            if (objProjectCompany.selectedItems == undefined || objProjectCompany.selectedItems.length == 0) {
                var objProject = this.projectsFin.find(fld => fld.hashTrack.find(fldHash => fldHash._id == element.hashTrackId) != undefined);
                
                if (objProject != undefined) {
                    this.toastr.onClickToast()
                      .subscribe( toast => {
                        this.router.navigate([`/projects/edit/${objProject._id}`]);
                        this.toastr.dismissToast(toast);
                      });
                    this.toastr.error(`O projeto "${element.name}" está vinculado ao projeto do Financial "${objProject.name}" do cliente "${objProject.company.name}". Para vincular ao cliente correto, clique aqui!`,'Projeto vinculado ao cliente errado!',{
                      toastLife:100000,
                      showCloseButton: true
                    });
                } else {
                    this.toastr.onClickToast()
                    .subscribe( toast => {
                      this.router.navigate(['/projects/new']);
                      this.toastr.dismissToast(toast);
                    });
                    this.toastr.error(`"${element.name}" não possui vínculo com um projeto do Financial. Para vincular, clique aqui!`,'Projeto não vinculado!',{
                      toastLife:100000,
                      showCloseButton: true
                    });
                }
            }
        });
      }

    sumProjectHours(approval){
        let projects = approval.projects,
            total = 0;
        projects.forEach(element => {
            let hours = element.total_hours;
            total = total + hours;
        });
        this.totalProjectHours = total;
        this.approval.elegibleForDiscount = this.elegibleForDiscount()
    }

    elegibleForDiscount(){
        let response = new ElegibleForDiscount();
        
        if(this.totalProjectHours < this.mensalHours)
          response.byContract = true;
        if(this.days && (this.totalProjectHours < this.days*8))
          response.byCapacity = true
        
          return response;
      }

    getKind() {
        switch(this.approval.consultant.contract.kind) {
            case 1:
                return 'PJ';

            case 2:
                return 'CLT';

            case 3:
                return 'Estágio';

            case 4:
                return 'Outros';

        }
    }

    getHonorarium() {
        if(this.approval.consultant.contract.honorarium){
            switch(this.approval.consultant.contract.honorarium){
                case 1:
                    return 'Hora Aberta';

                case 2:
                    return 'Hora Fechada';
            }
        }else{
            return null;
        }

    }

    setValues(approval){
        if(approval.consultant.contract.mensalHours)
            this.mensalHours = approval.consultant.contract.mensalHours;

        this.hourValue = approval.consultant.contract.hourValue;

        if(approval.consultant.contract.totalValue)
            this.contractTotalValue = approval.consultant.contract.totalValue;

        this.kind = approval.consultant.contract.kind;

        if(approval.consultant.contract.honorarium)
            this.honorarium = approval.consultant.contract.honorarium;

        if(approval.approvalType)
            this.approvalType = this.approvalType;

        this.status = approval.status;

        this.sumProjectHours(this.approval);
        this.approval.realizedHours = this.totalProjectHours;
    }

    getDiscountedHours(){
        if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 1 && this.descontar && this.mensalHours > this.totalProjectHours){
            return (this.mensalHours-this.totalProjectHours);
        }else if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) &&this.approvalType == 2 && this.days && this.descontar && (this.days*8)>this.totalProjectHours){
            return (this.days*8-this.totalProjectHours);
        }else if(!this.descontar){
            return this.totalProjectHours;
        }else{
            return 0;
        }
    }

    getDiscountedValue(){
        if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 1 && this.descontar && this.mensalHours>this.totalProjectHours){
            return this.approval.consultant.contract.totalValue-(this.mensalHours-this.totalProjectHours)*this.hourValue;
        }else if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 2 && this.days && this.descontar && (this.days*8)>this.totalProjectHours){
            return this.approval.consultant.contract.totalValue - (this.days*8-this.totalProjectHours)*(this.approval.consultant.contract.totalValue/(this.days*8));
        }else {
            this.totalValue = this.approval.consultant.contract.hourValue * this.approval.realizedHours;
            return this.totalValue;
        }
    }

    OnCancel(){
        this.ApprovalService.multiApprovals = [];
        this.router.navigate(['/approvals']);
    }

    localStorageDays(){
        localStorage.setItem('days', this.days);
    }

    valueCheck(projectHours, totalValue){

        switch (this.approval.consultant.contract.kind) {
            case 1:
              if (this.approval.consultant.contract.honorarium == 1 && projectHours < totalValue)
                  return true;
              else {
                  if ((this.approval.consultant.contract.honorarium == 2) &&
                      this.checkContractDiferentHours(projectHours, totalValue))
                      return true;
                  else
                      return this.hoursBiggerContract();
              }
            case 2:
              if (this.checkContractDiferentHours(projectHours, totalValue))
                  return true;
              else
                  return this.hoursBiggerContract();
          default:
              return false;
        }
    }

    hoursBiggerContract() {
        if (this.approvalType == 2) {
            this.horasAMaisMesDescontar = (this.days * 8) - Number(this.approval.consultant.contract.mensalHours);
        }
        if (this.approvalType == 1){
            this.horasAMaisMesDescontar = 0;
        }
        return false;
    }

    checkContractDiferentHours(projectHours, totalValue){
        return !this.extras && (Math.abs(projectHours - totalValue)<= 1 || Math.abs(projectHours - totalValue)>= 1);
    }

    checkElegibleForDiscount(approvalType:number, checkType:string){
        if(this.approval.elegibleForDiscount && this.approval.elegibleForDiscount[checkType] == false && this.descontar && this.approvalType == approvalType){
            return true;
        }
        return false;
    }

    checkHonorarium(){

        if(this.kind == 1 && this.approval.consultant.contract.honorarium == 1){
            return true;
        }
        return false;
    }

    checkForExtras(approvalType:number){

        if(this.extras && this.approvalType == 1){
            if(this.totalProjectHours < this.mensalHours)
                return true;
        }else if(this.extras && this.days && this.approvalType == 2){
            if(this.totalProjectHours < this.days*8){
                return true;
            }
        }
        return false;
    }

    enableFailClass(){
        if(this.checkElegibleForDiscount(1,"byContract") && this.descontar && this.approvalType == 1)
            return true;
        if(this.checkElegibleForDiscount(2,"byCapacity") && this.descontar && this.approvalType == 2)
            return true;
        if(this.checkForExtras(this.approvalType) && this.extras)
            return true;
        if((this.checkHonorarium() && this.extras) || (this.checkHonorarium() && this.extras))
            return true;
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/approvals/approval-box/approval-box.component.ts